// Imports the React library to enable JSX syntax and React features.
import React from 'react';
// Imports the ReactDOM package for rendering your app into the DOM.
import ReactDOM from 'react-dom/client';
// Imports BrowserRouter as Router from react-router-dom for client-side routing.
import { BrowserRouter as Router } from 'react-router-dom';
// Imports the ScrollToTop component, which presumably handles scrolling to the top of the page on route changes.
import { ScrollToTop } from "./components";

// Imports the main stylesheet for the application.
import './index.css';
// Imports the main App component, which is the root of your React application.
import App from './App';

// Creates a root DOM element for React to manage, using the element with the ID 'root'.
const root = ReactDOM.createRoot(document.getElementById('root'));
// Renders your React application into the DOM. The entire app is wrapped with <React.StrictMode> for additional checks and warnings in development.
root.render(
  <React.StrictMode>
    <Router>
      {/* Wraps the entire application in a Router component to enable client-side navigation and routing without refreshing the page. */}
      <ScrollToTop />
      {/* ScrollToTop component is likely used here to ensure that the viewport scrolls to the top when navigating to a new route. */}
      <App />
      {/* The main App component that contains the rest of your application. */}
    </Router>
  </React.StrictMode>
);
